import React from 'react'
import BaseQueryControlComponent from './BaseQueryControlComponent'
import ResultItemComponent from './ResultItemComponent'
import { Grid, Row, Col, Panel, PanelGroup } from 'react-bootstrap'
import { getColSize } from '../../helpers/common'
import Icon from 'react-fa'
import { checkAccessLevel } from '../../helpers/access'
import { t } from '../../helpers/translate'


let config = require('config');

class ListingComponent extends BaseQueryControlComponent {
  constructor(props) {
    super(props);
    const headerTitles = config.default.listing[this.props.searchType]
    let sortables = []

    headerTitles.map(() => {
      sortables.push({asc: false, desc: false});
    })

    this.state = {
      headerTitles: headerTitles,
      sortables: sortables
    }
  }
  generateListingHeader() {
    const padding = ['bulkuploadlist', 'report'].includes(this.props.searchType) ? '' : 'padding-right';
    return (
      <Panel className="listing-header">
        <Grid fluid>
          <Row className={`${padding} header-flex`}>
            {this.state.headerTitles.map((element, index) => {
              return <Col className='listing-col' sm={getColSize(element)}>
                        {this.sortableCode(index)}
                        {element.sortable ? <a onClick={() => this.sortResults(index)}>{t(element.label)}</a> : t(element.label)}
                      </Col>
            })}
          </Row>
        </Grid>
      </Panel>
    );
  }

  sortableCode(index){
    const element = this.state.headerTitles[index]
    let isAsc =  this.state.sortables[index].asc
    let isDesc = this.state.sortables[index].desc

    if (element.field_name == this.props.orderby){
      isAsc = (this.props.order == 'asc')
      isDesc = !isAsc
    }

//reset situation if sorting is by the default value of sale_date
    if (this.props.orderby =='sale_date'){
      isAsc  = false
      isDesc = false
    }
    return element.sortable ?
      <span>
        <Icon name="chevron-up" className={`${isAsc ? '' : 'hidden'}`}/>
        <Icon name="chevron-down" className={`${isDesc ? '' : 'hidden'}`}/>
          &nbsp;
      </span> : null
  }
  sortResults(index){
    const isDesc = this.state.sortables[index].desc

    this.state.sortables.forEach((el,index) => {
      this.state.sortables[index] = {asc: false, desc: false};
    });

    this.state.sortables[index].asc = isDesc
    this.state.sortables[index].desc = !isDesc

    this.setState({sortables: this.state.sortables});

    this.updateCurrentQuery({
      orderby: this.state.headerTitles[index].field_name,
      order: isDesc ? 'asc' : 'desc'
    })
  }
  getPolicyNumber() {
    return this.props.item.policy_number;
  }

  getItemHeaders(item){
    switch(this.props.searchType){
      case 'applicant':
        return [
          item.policy_number,
          item.app_status,
          item.first_name,
          item.last_name,
          item.dob,
          item.application.effective_date,
          item.application.expiry_date,
          !checkAccessLevel('viewonly') && `$${item.application.premium} ${item.currency}`,
          `${item.application.source_full_name} ${item.application.source_category}`,
        ].filter(Boolean)
      
      case 'user':
        return [
          item.data.csr_token,
          item.first_name,
          item.last_name,
          item.email,
          item.user_type,
          item.status,
        ]
      
      case 'quote':
        return [
          item.reference_id,
          item.application.status,
          item.first_name,
          item.last_name,
          item.dob,
          item.quote_date,
          `${item.application.source_full_name} ${item.application.source_category}`,
        ]

      case 'claim':
        return [
          item.claim_id,
          item.policy_number,
          item.first_name,
          item.last_name,
          item.created_at,
        ]

      case 'bulkuploadlist':
        return [
          `${item.source_name} ${item.source_category}`,
          item.created_at.split(' ')[0],
          item.completed + item.failed + item.queued,
          item.completed,
          item.failed,
          item.queued,
          item.school_name,
          item.uploader,
          item.status.charAt(0).toUpperCase() + item.status.slice(1),
        ]

      case 'uploaddetails':
        const effDate = item.effective_date;
        const expDate = item.expiry_date;
        const status = item.status;
        return [
          item.policy_number,
          status ? status.charAt(0).toUpperCase() + status.slice(1) : null,
          item.first_name,
          item.last_name,
          item.dob,
          effDate ? effDate : null,
          expDate ? expDate : null,
        ]

      case 'report':
        return [
          item.created_at,
          item.status,
          item.report_type,
          item.first_name,
          item.last_name,
          `${item.source_full_name} ${item.source_category}`,
        ]
      default:
        return []
    }
  }

  render() {
    const Tag = ResultItemComponent;
    return (
      <div>
        {this.generateListingHeader()}
        <PanelGroup>
          {this.props.dataArray.map((item, i) =>
            <Tag
              key={i}
              groups={this.props.config.compact}
              headers={this.getItemHeaders(item)}
              item={item}
              params={config.default.listing[this.props.searchType]}
              {...this.props}
            />
          )}
        </PanelGroup>
      </div>
    );
  }
}

ListingComponent.displayName = 'ListingComponent';
export default ListingComponent;



// WEBPACK FOOTER //
// ./src/components/common/ListingComponent.js